<script>
import util from '@/util/util.js'
const imageUrl = `${util.ImageUrl}`;
const url =  `${util.baseUrl}`;
export default {
  imageUrl, //用户地址
  url
};
</script>